import styled from 'styled-components';
import { textTransform } from 'utils';

export const H2Div = styled.div`
  font-style: normal;
  font-weight: 450;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 3px;
  text-transform: ${textTransform};
  color: #ffffff;
  // margin-top: 25px;
`;

export const H4Div = styled.div`
  font-size: 22px;
  line-height: 34px;
  -webkit-letter-spacing: 3px;
  -moz-letter-spacing: 3px;
  -ms-letter-spacing: 3px;
  letter-spacing: 1px;
  text-transform: ${textTransform};
  color: #ffffff;
  margin-bottom: 20px;
  // font-family: monospace;
`;

export const PDiv = styled.div`
  font-style: normal;
  font-weight: 100;
  font-size: 18px;
  line-height: 30px;
  color: #ffffff;
  // font-family: 'Circular-Loom';
  letter-spacing: 1px;
  margin-bottom: 30px;
  span {
    color: #de1619;
  }
  p {
    margin-bottom: 10px;
  }
  ul {
    margin-bottom: 20px;
  }
  ul li {
    display: block;
    font-size: 16px;
    line-height: 24px;
    font-weight: 100;
  }
  ul li:before {
    content: "✔";
    color: #ff0000;
    margin-right: 10px;
    font-size: 20px;
  }
`;

export const SectionTop = styled.div`
// float: left;
  width: 100%;
  margin: 30px auto;
  max-width: 80%;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const SectionTopNext = styled.div`
  float: left;
  width: 100%;
  margin: 30px auto;  
`;

export const SectionSecond = styled.div`
  text-align: center;
  // float: left;
  width: 100%;
  margin: 30px auto;
  max-width: 80%;
  @media (max-width: 768px) {
    max-width: 100%;
  }
  img {
    margin: 0px 0px 40px 0px;
    width: 50%;
  }
  a.order_btn {
    padding: 15px 30px;
    background: #de1619;
    border-radius: 25px;
    color: #fff;
    letter-spacing: 2px;
    font-weight: 500;
    font-size: 13px;
    margin-bottom: 30px;
  }
  p {
    color: #888888;
    font-style: normal;
    font-weight: 390;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    margin-bottom: 30px;
    letter-spacing: 1px;
  }
  .gift_btn {
    padding: 15px 30px;
    border: 2px solid rgba(255, 255, 255, 0.498641);
    border-radius: 25px;
    color: #fff;
    letter-spacing: 2px;
    font-weight: 500;
    font-size: 13px;
    margin-bottom: 30px;
    text-transform: ${textTransform};
  }
`;

export const SectionThird = styled.div`
  // float: left;
  width: 100%;
  margin: 30px auto;
  max-width: 80%;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const SectionFour = styled.div`
  // float: left;
  width: 100%;
  margin: 30px auto;
  max-width: 80%;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const Fullwidth = styled.div`
  width: 100%;
  text-align: center;
  img {
    width: 65%;
  }
`;

export const FullwidthCarousel = styled.div`
  width: 100%;
  float: left;
  padding: 30px 20px;
  background: #2d2d2d;
  margin: 30px 0px;
  .giftCardSlider {
    padding: 10px;
  }
  .giftCardSlider img {
    width: 100%;
  }
  h2 {
    font-size: 21px;
    line-height: 28px;
    letter-spacing: 1.5px;
    text-transform: ${textTransform};
    color: #ffffff;
    margin: 15px 0px;
    // font-family: sans-serif;
    font-weight: 100;
  }
  p {
    font-size: 16px;
    line-height: 26px;
    color: #979797;
    letter-spacing: 1px;
    font-weight: 100;
    // font-family: sans-serif;
  }
`;

export const GiftDisplaySection = styled.div`
  width: 100%;
  float: left;
  margin: 10px 0px;
`;

export const GiftTitle = styled.div`
  width: 100%;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #ffffff;
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
  margin-bottom: 20px;
`;

export const List = styled.div`
  margin: 10px 0px;
  span.right_check {
    margin-right: 10px;
  }
  span.left_content {
    font-size: 18px;
    line-height: 24px;
    color: #ffffff;
    letter-spacing: 1px;
  }
`;

export const DivSet4 = styled.div`
  width: 33.33%;
  float: left;
  margin-top: 20px;
  h2 {
    font-size: 22px;
    line-height: 24px;
    letter-spacing: 1px;
    color: #ffffff;
    font-weight: 100;
    margin-bottom: 20px;
  }
  ul {
    width: 100%;
    float: left;
    li, a {
      display: block;
      color: #de1619;
      font-size: 20px;
      line-height: 24px;
      font-weight: 100;
      margin: 5px 0px;
      letter-spacing: 1px;
    }
  }
  @media (max-width: 768px) {
    width: 50%;
  }
  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const SectionFive = styled.div`
  width: 100%;
  float: left;
  margin: 30px 0px;
`;
